export enum MaturityLevel {
  INITIAL = 'INITIAL',
  REPEATABLE = 'REPEATABLE',
  DEFINED = 'DEFINED',
  MANAGED = 'MANAGED',
  OPTIMIZING = 'OPTIMIZING',
  NULL = 'null'
}
